<template>
  <Modal title="Title" v-model="showUserModal" class-name="vertical-center-modal card-modal" :width="800">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>
    <Form ref="userForm" :model="userForm" :rules="ruleValidate" :label-width="90" label-position="top">
      <Row class="widget-container">

        <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-bottom: 20px">
          <FormItem label="First name" prop="firstName">
            <Input v-model="userForm.firstName"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-bottom: 20px">
          <FormItem label="Middle name" prop="middleName">
            <Input v-model="userForm.middleName"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-bottom: 20px">
          <FormItem label="Last name" prop="lastName">
            <Input v-model="userForm.lastName"></Input>
          </FormItem>
        </i-col>


        <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-bottom: 20px">
          <FormItem label="Address" prop="address">
            <Input v-model="userForm.address"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-bottom: 20px">
          <FormItem label="City" prop="city">
            <Input v-model="userForm.city"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="8" :lg="8" style="padding-bottom: 20px">
          <FormItem label="Country" prop="country">
            <Input v-model="userForm.country"></Input>
          </FormItem>
        </i-col>

        <i-col :xs="24" :sm="24" :md="12" :lg="12" style="padding-bottom: 20px">
          <FormItem label="Phone" prop="phone">
            <Input v-model="userForm.phone"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="12" :lg="12" style="padding-bottom: 20px">
          <FormItem label="E-Mail" prop="email">
            <Input v-model="userForm.email"></Input>
          </FormItem>
        </i-col>

        <i-col :xs="24" :sm="24" :md="12" :lg="12" style="padding-bottom: 20px">
          <FormItem label="User Name" prop="userName">
            <Input v-model="userForm.userName"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="12" :lg="12">
          <FormItem label="Password" prop="password">
            <Input v-model="userForm.password"></Input>
          </FormItem>
        </i-col>

      </Row>
    </Form>
    <div slot="footer">
      <Button size="large" @click="handleReset('userForm');showUserModal=false">Cancel</Button>
      <Button size="large" class="submit" type="success"
              @click="handleCreate('userForm')" v-if="action=='add'">Save
      </Button>
      <Button size="large" class="submit" type="success"
              @click="handleUpdate('userForm',userForm.userId)" v-if="action=='edit'">Save
      </Button>
    </div>
  </Modal>
</template>
<script>
  import {addUser, updateUser} from '../../services/User.service'
  import {bus} from '../../main'

  export default {
    props: [],
    data() {
      return {
        action: 'add',
        title: 'ADD USER',
        showUserModal: false,
        userForm: {
          userId: null,
          userRoleId: null,
          managerId: null,
          companyId: null,
          userName: null,
          password: null,
          firstName: null,
          middleName: null,
          lastName: null,
          address: null,
          city: null,
          country: null,
          phone: null,
          email: null,
          createdBy: null,
          createdDate: null,
          updatedBy: null,
          updatedDate: null,
          deleted: null,
          deletionDate: null,
        },
        indeterminate: null,
        checkAll: false,
        ruleValidate: {
          firstName: [{required: true, message: 'First name cannot be empty', trigger: 'blur'}],
          lastName: [{required: true, message: 'Last name cannot be empty', trigger: 'blur'}],
          email: [
            {required: true, message: 'Email cannot be empty', trigger: 'blur'},
            {type: 'email', message: 'Incorrect email format', trigger: 'blur'}
          ],
          phone: [{required: false, message: 'Phone cannot be empty', trigger: 'blur'}],
          userName: [{required: true, message: 'User Name cannot be empty', trigger: 'blur'}],
          password: [{required: true, message: 'Password cannot be empty', trigger: 'blur'}],
          city: [{required: true, message: 'City cannot be empty', trigger: 'blur'}],
          country: [{required: true, message: 'Country cannot be empty', trigger: 'blur'}],
        }
      }
    },
    watch: {},
    created() {
      setTimeout(function () {
        let elements = document.getElementsByClassName('ivu-form-item-content');
        for (var i = 0; i < elements.length; i++) {
          elements[i].setAttribute('style', null);
        }

        let labels = document.getElementsByClassName('ivu-form-item-label');
        for (var i = 0; i < labels.length; i++) {
          labels[i].style.textAlign = 'left';
        }

      }, 300);
    },
    methods: {
      openUserForm(title, action, companyId) {
        this.handleReset('userForm')
        this.showUserModal = true;
        this.title = title;
        this.action = action;
        this.userForm.companyId = companyId;
      },
      handleCreate(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            const data = Object.assign({}, this.userForm);
            data['userId'] = 0;
            data['userRoleId'] = 3;
            data['managerId'] = data.managerId;
            data['companyId'] = parseInt(localStorage.getItem('selected_company_users'));
            data['userName'] = data.userName;
            data['password'] = data.password;
            data['firstName'] = data.firstName;
            data['middleName'] = data.middleName;
            data['lastName'] = data.lastName;
            data['address'] = data.address;
            data['city'] = data.city;
            data['country'] = data.country;
            data['phone'] = data.phone;
            data['email'] = data.email;
            data['deleted'] = false;

            this.showUserModal = false;
            addUser(data).then(response => {
              data['userId'] = response.data;
              this.$emit('addUser', data);
              this.$Message.success('User successfully added!');
              bus.$emit('reloadUsers', (data.companyId));
            }).catch(error => {
              console.log(error.response);
              if (error.response.request.responseText) {
                let errResponse = JSON.parse(error.response.request.responseText)
                Object.keys(errResponse).map(key => {
                  errResponse[key].map(errMsg => {
                    this.$Message.error(errMsg);
                  })
                })
              } else {
                this.$Message.error('Failed adding user');
              }
            })
          }
        })
      },
      handleUpdate(name, id) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.showUserModal = false
            const data = Object.assign({}, this.userForm);
            updateUser(id, data).then(response => {
              this.$emit('updateUser', id, data);
              this.$Message.success('User successfully update!');
              bus.$emit('reloadUsers', (data.companyId));
            }).catch(error => {
              this.$Message.error('Failed updating user');
            })
          }
        })
      },
      setFormValue(params, index) {
        let data = Object.assign({}, params);
        delete data['inverseManager']
        delete data['userTeam']
        delete data['privilegesUsers']
        delete data['_index']
        delete data['_rowKey']
        this.userForm = data
      },
      handleReset(name) {
        this.$refs[name].resetFields();
        let self = this;
        Object.keys(self.userForm).forEach(function (key, i) {
          self.userForm[key] = '';
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/i_users/UserForm.vue